import { Item } from '@src/components/Header/MenuItem'
import { supportPageLinks } from '@src/state/site/siteConfig'
import { EASYBIB } from '@src/state/site/types'
import urlPrefix from '@src/utils/easybibUrlPrefix'

export interface NavRoute {
  name: string
  href: string
  isCitationSite: boolean
  requiresUser: boolean
  requiresGuest?: boolean
  requiredSite?: string
  onClick?: () => void
}

export const topNavRoutes: NavRoute[] = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    isCitationSite: true,
    requiresUser: false,
  },
  {
    name: 'Citations',
    href: '/mla8/source',
    isCitationSite: true,
    requiresUser: false,
  },
  {
    name: 'Papers',
    href: '/grammar-and-plagiarism',
    isCitationSite: true,
    requiresUser: false,
    requiresGuest: true,
  },
  {
    name: 'Papers',
    href: '/',
    isCitationSite: false,
    requiresUser: true,
  },
  {
    name: 'Guides',
    href: '/guides',
    isCitationSite: true,
    requiresUser: false,
    requiredSite: EASYBIB,
  },
]

// These menu items are only rendered for Easybib
//  so text + urls are not parameterized.
export const menuItems: Item[] = [
  {
    name: 'EasyBib Plus',
    icon: 'easybib-plus',
    href: urlPrefix({ path: '/upgrade' }),
    id: 4,
  },
  {
    name: 'About Us',
    icon: 'about-us',
    href: urlPrefix({ path: '/company' }),
    id: 5,
  },
  {
    name: 'Support',
    icon: 'support',
    href: `${supportPageLinks.easybib}/?Website=External`,
    id: 6,
  },
]



// WEBPACK FOOTER //
// ./src/components/Header/routes.tsx